import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { colors, theme } from "../../theme/theme";
import { CustomBtn } from "../Common/CustomBtn";
import {
  ChatOutlined,
  MoreVertOutlined,
  PeopleOutlineOutlined,
  PersonOutlineOutlined,
  ShareOutlined,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

const GroupCard = ({ item, index, setGroupDetail, setGroupId, joinGroup }) => {
  const { userData } = useSelector((state) => state.user);

  const groupMember = item?.memberUserIds?.find(
    (member) => member === userData?.id
  );

  return (
    <Grid
      container
      spacing={2}
      sx={{
        backgroundColor: "transparent",
        border: theme.lightBorder,
        borderRadius: "14px",
        mb: 2,
        width: "100%",
        overflow: "hidden",
      }}
      key={index}
    >
      <Grid
        item
        size={{ xs: 12, sm: 3 }}
        sx={{ cursor: "pointer" }}
        onClick={() => {
          setGroupDetail(true);
          setGroupId(item?.id);
        }}
      >
        <img
          src={item?.image_url}
          alt={item?.title}
          style={{
            width: "100%",
            height: "100%",
            borderTopLeftRadius: "14px",
            borderBottomLeftRadius: "14px",
            objectFit: "cover",
          }}
        />
      </Grid>
      <Grid item size={{ xs: 12, sm: 9 }}>
        <Box sx={{ p: 2 }}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography
              sx={{
                fontFamily: "Mulish-Bold",
                fontSize: "24px",
                color: "#fff",
              }}
            >
              {item?.title}
            </Typography>
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={1}
              sx={{
                width: "50%",
                justifyContent: "flex-end",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "12px",
                  fontFamily: "Mulish-Light",
                  mr: 2,
                }}
              >
                Get (14pt)
              </Typography>
              <CustomBtn
                text={groupMember ? "Joined" : "Join"}
                width="30%"
                height="40px"
                fontSize="16px"
                icon={!groupMember}
                onClick={() => {
                  if (groupMember) {
                    return;
                  } else {
                    joinGroup(userData?.id, item?.id);
                  }
                }}
                noClick={groupMember}
              />
              <IconButton>
                <ShareOutlined sx={{ fontSize: "16px", color: "#fff" }} />
              </IconButton>
              <IconButton>
                <MoreVertOutlined sx={{ fontSize: "16px", color: "#fff" }} />
              </IconButton>
            </Stack>
          </Stack>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: 2,
              mr: 2,
            }}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <ChatOutlined
                sx={{ color: colors.secondary, fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: "#fff",
                  fontFamily: "Mulish-Regular",
                  fontSize: "14px",
                }}
              >
                {item?.groupDiscussionsCount + " Discussions"}
              </Typography>
            </Stack>
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <PeopleOutlineOutlined
                sx={{ color: colors.secondary, fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: "#fff",
                  fontFamily: "Mulish-Regular",
                  fontSize: "14px",
                }}
              >
                {item?.memberUserIds?.length + " Members"}
              </Typography>
            </Stack>
          </Box>
          <Box>
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <PersonOutlineOutlined
                sx={{ color: colors.secondary, fontSize: "20px" }}
              />
              <Typography
                sx={{
                  color: "#fff",
                  fontFamily: "Mulish-Regular",
                  fontSize: "14px",
                }}
              >
                Created by{" "}
                <Typography
                  component={"span"}
                  sx={{
                    color: colors.secondary,
                    fontFamily: "Mulish-Medium",
                    fontSize: "14px",
                    cursor: "pointer",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  {item?.user?.firstName}
                </Typography>
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default GroupCard;
